import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const Email2FormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='EMAIL 2' htmlFor='input-email2' sm={2} alignRightAt='sm' />
      <Col sm={10}>
        <Field name='email2'>
          {({ field }) => (
            <Form.InputEmail
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-email2'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(Email2FormGroup)
